// Accepted credit card types

export default [
  'visa',
  'american-express',
  'discover',
  'mastercard',
  'diners-club',
  'unionpay',
  'rei-mastercard',
]
